<tran-ui-content-section [backgroundImage]="backgroundImage()" [showOverlay]="true">
    <div class="pt-20 pb-[104px]">
        <div class="flex flex-col !gap-4 pt-6 pb-20">
            <p class="font-bold text-topline-l uppercase">
                {{ eyebrow() | translate }}
            </p>
            <h2 class="text-hero-l2 flex flex-col">
                <span>{{ titleKey() | translate }}</span>
                <span class="font-bold">{{ boldTitle() | translate }}</span>
            </h2>
        </div>
        <ng-content slot="above" />
        <tran-steps [steps]="steps()" />
        <ng-content slot="below" />
    </div>
</tran-ui-content-section>
